import React, { useEffect, useState } from "react";
import useFirebase from "../../../../../useFirebase";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import useDurationOption from "../../../../customHooks/durationOption";
import Select from "react-select";
import useTimeSupervision from "../TimeSupervision/useTimeSupvervision";
import { screenshotSettings } from "../../../AxiosRtk/SetRules";

const pathKeys = {
  "/keystrokes-select-apps": { key: "isKeystrokeEnabled", type: "number" },
  "/screen-shot-select-apps": { key: "screenshotEnable", type: "number" },
  "/social-media-select-apps": {
    key: "socialMediaCommunicationStatus",
    type: "boolean",
  },
  "/social-media-select-apps-for-screenshot": {
    key: "socialMediaScreenshotsStatus",
    type: "boolean",
  },
};

const ScreenShots = ({ deviceSelected, getLangTranslation, kidData }) => {
  const pathname = "/social-media-select-apps-for-screenshot";
  const dispatch = useDispatch();
  const { hourMinOptionFunction } = useDurationOption();
  const hourMinOptions = hourMinOptionFunction();

  const [timeWise, setTimeWise] = useState("MIN");
  const [keyword, setKeyword] = useState("");
  const [isDisabled, setIsDisabled] = useState(true); // Initially disabled
  const [time, setTime] = useState(0);
  const [allowedApps, setAllowedApps] = useState([]);
  const { keyStrokesModifiedData } = useTimeSupervision();
  const [normalFormattedAllowedApps, setNormalFormattedAllowedApps] = useState([]);
  const [normalFormatAllowedApps, setNormalFormatAllowedApps] = useState([]);
  const [timer, setTimer] = useState(null);

  const [toggleData, setToggleData] = useState({
    enableScreenshot: 0,
    takeScreenshotWhenInstallNewApp: 0,
    takeScreenShotWhenAccessBlockedWarnedWebsite: 0,
    takeScreenShotTypeKeywords: 0,
    detectTextContentScreenshot: 0,
    keystrokeKeywords: [],
    captureInterval: -1,
    screenshotAllowMeReadTextOrSendAlert: 0,
  });

  const [originalToggleData, setOriginalToggleData] = useState({});

  const history = useHistory();
  const { getCollectionData, postCollectionData, createCollectionData } = useFirebase();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [socialAppData, setSocialAppData] = useState([]);

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  useEffect(() => {
    getCollectionData("AdminSetRuleData", "socialApps")
      .then((res) => {
        setSocialAppData(res?.apps ?? []);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    if (setRulesData?.screenshotsSettings) {
      const {
        capture_interval,
        capture_when_accessing_blocked_site,
        capture_when_badwords,
        capture_when_new_app_install,
        screenshotSmartTextDetection,
        screenshot_settings_enabled,
        screenshots_allowmeread_text_or_send_alert,
      } = setRulesData?.screenshotsSettings;

      const newToggleData = {
        enableScreenshot: screenshot_settings_enabled,
        takeScreenshotWhenInstallNewApp: capture_when_new_app_install,
        takeScreenShotWhenAccessBlockedWarnedWebsite: capture_when_accessing_blocked_site,
        takeScreenShotTypeKeywords: capture_when_badwords,
        detectTextContentScreenshot: screenshotSmartTextDetection,
        screenshotAllowMeReadTextOrSendAlert: screenshots_allowmeread_text_or_send_alert,
      };

      setToggleData(newToggleData);
      setOriginalToggleData(newToggleData);
      setTime(capture_interval ?? 0);
    } else {
      const initialData = {
        enableScreenshot: 0,
        takeScreenshotWhenInstallNewApp: 0,
        takeScreenShotWhenAccessBlockedWarnedWebsite: 0,
        takeScreenShotTypeKeywords: 0,
        detectTextContentScreenshot: 0,
        keystrokeKeywords: [],
      };

      setToggleData({ ...initialData });
      setOriginalToggleData({ ...initialData });
      setTime(0);
    }

    if (setRulesData?.keystrokesmonitoring) {
      const keystrokeKeywords = [
        ...(setRulesData?.keystrokesmonitoring?.keystrokesdata?.keystroke_keywords || []),
      ];
      setToggleData((prevState) => ({
        ...prevState,
        keystrokeKeywords: keystrokeKeywords.map((keyword) => ({
          id: Math.floor(Math.random() * Math.pow(10, 5)),
          keyName: keyword,
        })),
      }));
      setOriginalToggleData((prevState) => ({
        ...prevState,
        keystrokeKeywords: keystrokeKeywords.map((keyword) => ({
          id: Math.floor(Math.random() * Math.pow(10, 5)),
          keyName: keyword,
        })),
      }));
    }

    if (setRulesData) {
      const otherAllowedApps =
        setRulesData?.timesupervison?.allowedApps?.length > 0
          ? setRulesData?.timesupervison?.allowedApps.filter((item) =>
              socialAppData?.find((sadItem) => sadItem?.package === item?.appPackageName)
            )
          : socialAppData;

      setNormalFormatAllowedApps(otherAllowedApps);
      const tempAllowedApps = setRulesData?.timesupervison?.allowedApps ?? [];
      setNormalFormattedAllowedApps(tempAllowedApps);
      const modifiedData = keyStrokesModifiedData(tempAllowedApps);
      setAllowedApps(modifiedData);
    } else {
      setNormalFormattedAllowedApps([]);
      setNormalFormatAllowedApps([]);
    }
  }, [setRulesData, socialAppData]);

  useEffect(() => {
    const isChanged = JSON.stringify(toggleData) !== JSON.stringify(originalToggleData);
    setIsDisabled(!isChanged);
  }, [toggleData, originalToggleData]);

  function callFirebase(payload, isToggleOn = false, checked) {
    let finalPayload = {};
    if (isToggleOn) {
      finalPayload = {
        setRulesActiveInActiveStatus: {
          ...setRulesData?.setRulesActiveInActiveStatus,
          screenshotsEnabled: checked,
        },
        screenshotsSettings: payload,
      };
    } else {
      finalPayload = {
        screenshotsSettings: payload,
      };
    }
    if (setRulesData) {
      postCollectionData(deviceSelected, finalPayload);
    } else {
      createCollectionData(deviceSelected, finalPayload);
    }
    getCollectionData(deviceSelected);
  }

  function callFirebaseUpdateKeywords(payload, isToggleOn = false, checked) {
    let finalPayload = {};
    if (isToggleOn) {
      finalPayload = {
        setRulesActiveInActiveStatus: {
          ...setRulesData?.setRulesActiveInActiveStatus,
          keysrtrokesMonitoringEnabled: checked,
        },
        keystrokesmonitoring: payload,
      };
    } else {
      finalPayload = {
        keystrokesmonitoring: payload,
      };
    }
    if (setRulesData) {
      postCollectionData(deviceSelected, finalPayload);
    } else {
      createCollectionData(deviceSelected, finalPayload);
    }
  }

  function callScreenshotApi(dbPayload) {
    screenshotSettings(dbPayload)
      .then(() => {})
      .catch((error) => {
        console.log("screenshot settings post data ==>>", error?.response?.data?.message);
      });
  }

  function callFirebase2(payload) {
    if (setRulesData) {
      postCollectionData(deviceSelected, payload);
    } else {
      createCollectionData(deviceSelected, payload);
    }
    getCollectionData(deviceSelected);
  }

  function handleEnableScreenshot(e) {
    const { name, checked, value } = e.target;
    let collectionPayload = "";
    if (name === "ENABLE_SCREENSHOT") {
      setToggleData({
        ...toggleData,
        enableScreenshot: checked ? 1 : 0,
      });
      collectionPayload = {
        ...setRulesData?.screenshotsSettings,
        screenshot_settings_enabled: checked ? 1 : 0,
      };
      callFirebase(collectionPayload, "YES", checked);
    } else if (name === "TAKE_SCREENSHOT_WHEN_INSTALL_NEW_APP") {
      setToggleData({
        ...toggleData,
        takeScreenshotWhenInstallNewApp: checked ? 1 : 0,
      });
    } else if (name === "TAKE_SCREENSHOT_WHEN_ACCESS_BLOCKED_WARNED_WEBSITE") {
      setToggleData({
        ...toggleData,
        takeScreenShotWhenAccessBlockedWarnedWebsite: checked ? 1 : 0,
      });
    } else if (name === "TAKE_SCREENSHOT_YOUR_CHILD_TYPE_KEYWORD") {
      setToggleData({
        ...toggleData,
        takeScreenShotTypeKeywords: checked ? 1 : 0,
      });
    } else if (name === "DETECT_TEXT_CONTENT_SCREENSHOT") {
      setToggleData({
        ...toggleData,
        detectTextContentScreenshot: checked ? 1 : 0,
      });
    } else if (name === "DETECT_TEXT_ALERT") {
      setToggleData({
        ...toggleData,
        screenshotAllowMeReadTextOrSendAlert: value,
      });
    }
  }

  function handleTimeChange(e) {
    let value = e.target.value;
    setTime(value);
  }

  // Original handleSave (renamed)
  function handleSaveOld() {
    setIsDisabled(true);
    const collectionPayload = {
      ...setRulesData,
      screenshotsSettings: {
        ...setRulesData?.screenshotsSettings,
        screenshot_settings_enabled: toggleData?.enableScreenshot ?? 0,
        capture_when_new_app_install: toggleData?.takeScreenshotWhenInstallNewApp ?? 0,
        capture_when_accessing_blocked_site: toggleData?.takeScreenShotWhenAccessBlockedWarnedWebsite ?? 0,
        capture_when_badwords: toggleData?.takeScreenShotTypeKeywords ?? 0,
        screenshotSmartTextDetection: toggleData?.detectTextContentScreenshot ?? 0,
        capture_interval: timeWise === "HRS" ? (time * 60)?.toString() : time?.toString(),
        screenshots_allowmeread_text_or_send_alert: parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) ?? 0,
      },
      timesupervison: {
        ...setRulesData?.timesupervison,
        allowedApps: normalFormattedAllowedApps,
      },
    };

    const dbPayload = {
      kidId: kidData?.ID,
      deviceId: deviceSelected,
      IsScreenshotSettingsEnabled: toggleData?.enableScreenshot ?? 0,
      IsCaptureWhenNewAppInstall: toggleData?.takeScreenshotWhenInstallNewApp ?? 0,
      IsCaptureWhenAccessingBlockedSite: toggleData?.takeScreenShotWhenAccessBlockedWarnedWebsite ?? 0,
      IsCaptureWhenBadwords: toggleData?.takeScreenShotTypeKeywords ?? 0,
      isScreenshotSmartTextDetection: toggleData?.detectTextContentScreenshot ?? 0,
      CaptureInterval: timeWise === "HRS" ? (time * 60)?.toString() : time?.toString(),
      screenshots_allow_me_read_text_or_send_alert: parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) ?? 0,
    };

    callScreenshotApi(dbPayload);
    callFirebase2(collectionPayload);
    setTimeout(() => {
      setIsDisabled(false);
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Data saved successfully",
          message: "DATA_SAVED",
        })
      );
    }, 1000);
  }

  // New handleSave with keyword persistence
  function handleSave() {
    setIsDisabled(true);

    const collectionPayload = {
      ...setRulesData,
      screenshotsSettings: {
        ...setRulesData?.screenshotsSettings,
        screenshot_settings_enabled: toggleData?.enableScreenshot ?? 0,
        capture_when_new_app_install: toggleData?.takeScreenshotWhenInstallNewApp ?? 0,
        capture_when_accessing_blocked_site: toggleData?.takeScreenShotWhenAccessBlockedWarnedWebsite ?? 0,
        capture_when_badwords: toggleData?.takeScreenShotTypeKeywords ?? 0,
        screenshotSmartTextDetection: toggleData?.detectTextContentScreenshot ?? 0,
        capture_interval: timeWise === "HRS" ? (time * 60)?.toString() : time?.toString(),
        screenshots_allowmeread_text_or_send_alert: parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) ?? 0,
      },
      timesupervison: {
        ...setRulesData?.timesupervison,
        allowedApps: normalFormattedAllowedApps,
      },
    };

    const dbPayload = {
      kidId: kidData?.ID,
      deviceId: deviceSelected,
      IsScreenshotSettingsEnabled: toggleData?.enableScreenshot ?? 0,
      IsCaptureWhenNewAppInstall: toggleData?.takeScreenshotWhenInstallNewApp ?? 0,
      IsCaptureWhenAccessingBlockedSite: toggleData?.takeScreenShotWhenAccessBlockedWarnedWebsite ?? 0,
      IsCaptureWhenBadwords: toggleData?.takeScreenShotTypeKeywords ?? 0,
      isScreenshotSmartTextDetection: toggleData?.detectTextContentScreenshot ?? 0,
      CaptureInterval: timeWise === "HRS" ? (time * 60)?.toString() : time?.toString(),
      screenshots_allow_me_read_text_or_send_alert: parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) ?? 0,
    };

    // Handle pending keywords from input (if any) and save to Firebase
    if (keyword) {
      const keywordSplitted = keyword.trim().split(",");
      const keywordArr = keywordSplitted?.map((item) => ({
        id: Math.floor(Math.random() * Math.pow(10, 5)),
        keyName: item,
      }));

      const newKeystrokeKeywords = [...(toggleData?.keystrokeKeywords ?? []), ...keywordArr];
      setToggleData({
        ...toggleData,
        keystrokeKeywords: newKeystrokeKeywords,
      });

      collectionPayload.keystrokesmonitoring = {
        ...setRulesData?.keystrokesmonitoring,
        keystrokesdata: {
          ...setRulesData?.keystrokesmonitoring?.keystrokesdata,
          keystroke_keywords: newKeystrokeKeywords?.map((item) => item?.keyName),
        },
      };

      setKeyword(""); // Clear input after adding to local state
    } else {
      // Include existing keywords in payload even if no new keyword is added
      collectionPayload.keystrokesmonitoring = {
        ...setRulesData?.keystrokesmonitoring,
        keystrokesdata: {
          ...setRulesData?.keystrokesmonitoring?.keystrokesdata,
          keystroke_keywords: toggleData?.keystrokeKeywords?.map((item) => item?.keyName),
        },
      };
    }

    callScreenshotApi(dbPayload);
    callFirebase2(collectionPayload);

    setTimeout(() => {
      setIsDisabled(false);
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Data saved successfully",
          message: "DATA_SAVED",
        })
      );
    }, 1000);
  }

  function handleKeywordRemove(id) {
    const keywordJson = [...toggleData?.keystrokeKeywords];
    const indexToRemove = keywordJson?.findIndex((item) => parseInt(item?.id) === parseInt(id));
    keywordJson.splice(indexToRemove, 1);

    setToggleData({
      ...toggleData,
      keystrokeKeywords: keywordJson,
    });

    if (timer) {
      clearTimeout(timer);
    }

    const timeoutTimer = setTimeout(() => {
      const collectionPayload = {
        keystrokesdata: {
          ...setRulesData?.keystrokesmonitoring?.keystrokesdata,
          keystroke_keywords: keywordJson?.map((item) => item?.keyName),
        },
      };
      callFirebaseUpdateKeywords(collectionPayload);
    }, 1000);
    setTimer(timeoutTimer);
  }

  // Original handleApply (renamed)
  function handleApplyOld() {
    if (!keyword) return;

    const keywordSplitted = keyword.trim().split(",");
    const keywordArr = keywordSplitted?.map((item) => ({
      id: Math.floor(Math.random() * Math.pow(10, 5)),
      keyName: item,
    }));

    const newArr = [...(toggleData?.keystrokeKeywords ?? []), ...keywordArr];
    const payload = {
      ...toggleData,
      keystrokeKeywords: newArr,
    };
    setToggleData(payload);
    setKeyword("");

    const collectionPayload = {
      keystrokesdata: {
        ...setRulesData?.keystrokesmonitoring?.keystrokesdata,
        keystroke_keywords: newArr?.map((item) => item?.keyName),
      },
    };

    callFirebaseUpdateKeywords(collectionPayload);
  }

  // New handleApply (local update only)
  function handleApply() {
    if (!keyword) return;

    const keywordSplitted = keyword.trim().split(",");
    const keywordArr = keywordSplitted?.map((item) => ({
      id: Math.floor(Math.random() * Math.pow(10, 5)),
      keyName: item,
    }));

    const newArr = [...(toggleData?.keystrokeKeywords ?? []), ...keywordArr];
    setToggleData({
      ...toggleData,
      keystrokeKeywords: newArr,
    });
    setKeyword(""); // Clear input after adding to local state
    // No Firebase call here; save happens in handleSave
  }

  function handleClearAll() {
    setKeyword("");
    setToggleData({
      ...toggleData,
      keystrokeKeywords: [],
    });
  }

  function checkStatus(type, value) {
    if (type === "number") {
      return value ? 1 : 0;
    }
    return value;
  }

  function handleScreenShotSelect(e) {
    const { name, checked } = e.target;
    let tempAllowedApps = [...normalFormattedAllowedApps];

    if (name === "allSelect") {
      tempAllowedApps = tempAllowedApps?.map((item) => {
        const tempObj = { ...item };
        tempObj[pathKeys[pathname]?.key] = checkStatus(pathKeys[pathname]?.type, checked);
        return tempObj;
      });
    } else {
      const indexToModified = tempAllowedApps?.findIndex(
        (item) => parseInt(item?.appUuid) === parseInt(name)
      );
      const gettingModifiableObj = { ...tempAllowedApps[indexToModified] };
      gettingModifiableObj[pathKeys[pathname]?.key] = checkStatus(
        pathKeys[pathname]?.type,
        checked
      );
      if (checked) {
        gettingModifiableObj["screenshotEnable"] = checkStatus(
          pathKeys["/screen-shot-select-apps"]?.type,
          checked
        );
      }
      tempAllowedApps.splice(indexToModified, 1, gettingModifiableObj);
    }
    setNormalFormattedAllowedApps(tempAllowedApps);
    const modifiedData = keyStrokesModifiedData(tempAllowedApps);
    setAllowedApps(modifiedData);
  }

  function handleScreenShotSelected(e) {
    const { name, checked } = e.target;
    let tempAllowedApps = [...normalFormatAllowedApps];

    if (name === "allSelect") {
      tempAllowedApps = tempAllowedApps?.map((item) => {
        const tempObj = { ...item };
        tempObj[pathKeys[pathname]?.key] = checkStatus(pathKeys[pathname]?.type, checked);
        return tempObj;
      });
    } else {
      const indexToModified = tempAllowedApps?.findIndex(
        (item) => parseInt(item?.appUuid) === parseInt(name)
      );
      const gettingModifiableObj = { ...tempAllowedApps[indexToModified] };
      gettingModifiableObj[pathKeys[pathname]?.key] = checkStatus(
        pathKeys[pathname]?.type,
        checked
      );
      if (checked) {
        gettingModifiableObj["screenshotEnable"] = checkStatus(
          pathKeys["/screen-shot-select-apps"]?.type,
          checked
        );
      }
      tempAllowedApps.splice(indexToModified, 1, gettingModifiableObj);
    }
    setNormalFormatAllowedApps(tempAllowedApps);
    const modifiedData = keyStrokesModifiedData(tempAllowedApps);
    setAllowedApps(modifiedData);
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
    (item) => item?.id === appLanguageId
  );

  return (
    <>
      {deviceSelected && (
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <div
            className={`form-check form-switch ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"}`}
          >
            <input
              className="form-check-input"
              id="enableScreenshot"
              name="ENABLE_SCREENSHOT"
              type="checkbox"
              role="switch"
              checked={toggleData?.enableScreenshot ?? 0}
              onChange={handleEnableScreenshot}
            />
            <label
              className="form-check-label text-blue-800 fw-semibold"
              htmlFor="enableScreenshot"
            >
              {getLangTranslation("SCREENSHOTS_ENABLE", "Enable")}
            </label>
          </div>
          <button
            className="btn btn-outline-primary d-inline-flex align-items-center gap-1"
            onClick={() => history.push("/screen-shot-select-apps")}
          >
            <i className="icon-plus fs-5" />
            <span className="btn-upper-case">
              {getLangTranslation("SCREENSHOTS_SELECT_APPS", "SELECT APPS")}
            </span>
          </button>
          {!!toggleData?.enableScreenshot && (
            <button
              className="btn btn-primary"
              onClick={handleSave} // Using new handleSave
              disabled={isDisabled}
            >
              <span className="btn-upper-case">
                {getLangTranslation("SAVE", "Save")}
              </span>
            </button>
          )}
        </div>
      )}

      {toggleData?.enableScreenshot === 1 && deviceSelected && (
        <>
          <hr />

          <div className="grid gap-6">
            <div
              className={`g-col-12 g-col-md-6 ${lang?.isRTL === 1 ? "border-start" : "border-end"}`}
            >
              <div className="form-check form-switch mb-6">
                <input
                  className="form-check-input"
                  id="optOne"
                  type="checkbox"
                  role="switch"
                  name="TAKE_SCREENSHOT_WHEN_INSTALL_NEW_APP"
                  checked={toggleData?.takeScreenshotWhenInstallNewApp ?? 0}
                  onChange={handleEnableScreenshot}
                />
                <label className="form-check-label text-dark" htmlFor="optOne">
                  {getLangTranslation(
                    "SCREENSHOTS_TAKE_A_SCREENSHOT_WHEN_INSTALLING_A_NEW_APP",
                    "Take a screenshot when installing a new app"
                  )}
                </label>
              </div>
              <div className="form-check form-switch mb-6">
                <input
                  className="form-check-input"
                  id="optTwo"
                  type="checkbox"
                  role="switch"
                  name="TAKE_SCREENSHOT_WHEN_ACCESS_BLOCKED_WARNED_WEBSITE"
                  checked={toggleData?.takeScreenShotWhenAccessBlockedWarnedWebsite ?? 0}
                  onChange={handleEnableScreenshot}
                />
                <label className="form-check-label text-dark" htmlFor="optTwo">
                  {getLangTranslation(
                    "SCREENSHOTS_TAKE_A_SCREENSHOT_WHEN_ACCESSING_A_BLOCKED_WEBSITE",
                    "Take a screenshot when accessing a blocked website or marked by warn"
                  )}
                </label>
              </div>
              <div className="form-check form-switch mb-6">
                <input
                  className="form-check-input"
                  id="optThree"
                  type="checkbox"
                  role="switch"
                  name="TAKE_SCREENSHOT_YOUR_CHILD_TYPE_KEYWORD"
                  checked={toggleData?.takeScreenShotTypeKeywords ?? 0}
                  onChange={handleEnableScreenshot}
                />
                <label className="form-check-label text-dark" htmlFor="optThree">
                  {getLangTranslation(
                    "SCREENSHOTS_TAKE_A_SCREENSHOT_IF_YOUR_CHILD_TYPES_A_KEYWORD",
                    "Take a screenshot if your child types a keyword"
                  )}
                </label>
              </div>
              <div className="form-check form-switch mb-6">
                <input
                  className="form-check-input"
                  id="optFour"
                  type="checkbox"
                  role="switch"
                  name="DETECT_TEXT_CONTENT_SCREENSHOT"
                  checked={toggleData?.detectTextContentScreenshot ?? 0}
                  onChange={handleEnableScreenshot}
                />
                <label className="form-check-label text-dark" htmlFor="optFour">
                  {getLangTranslation(
                    "SCREENSHOTS_DETECT_TEXT_ON_CAPTURED_SCREENSHOTS",
                    "Detect text on captured screenshots"
                  )}
                </label>
                <div className="fs-8">
                  {getLangTranslation(
                    "SCREENSHOTS_DETECT_TEXT_ON_CAPTURED_SCREENSHOTS_DESCRIPTION",
                    "This option will allow us to detect text on captured screenshots from social apps, and you will be able to know the full content of the conversations your child is doing."
                  )}
                </div>
              </div>
              <div
                className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
                role="alert"
              >
                <i className="icon-info-one fs-5" />
                {getLangTranslation(
                  "NUDITY_AND_IMAGE_DETECT_DESCLAIMER",
                  "Our image recognition is a good tool. However, be aware of the results. In some cases the result shown is incorrect. It is only for reference."
                )}
              </div>

              {toggleData?.detectTextContentScreenshot ? (
                <>
                  <div className="d-flex">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="DETECT_TEXT_ALERT"
                        id="checkOne"
                        value={0}
                        checked={parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) === 0}
                        onChange={handleEnableScreenshot}
                      />
                      <label className="form-check-label text-dark" htmlFor="checkOne">
                        {getLangTranslation(
                          "SCREENSHOT_SETTINGS_ALLOW_ME_TO_READ_DETECTED_TEXT_CONTENT",
                          "Allow me to read detected text content"
                        )}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="DETECT_TEXT_ALERT"
                        id="checkTwo"
                        value={1}
                        checked={parseInt(toggleData?.screenshotAllowMeReadTextOrSendAlert) === 1}
                        onChange={handleEnableScreenshot}
                      />
                      <label className="form-check-label text-dark" htmlFor="checkTwo">
                        {getLangTranslation(
                          "SCREENSHOT_SETTINGS_SEND_ME_ALERT_ON_THREAT_DETECTED",
                          "Send me only alert on threat detected"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="card m-3 p-3 social-apps">
                    {normalFormatAllowedApps?.map((item, index) => (
                      <div className="form-check form-switch form-check-right mb-4" key={index}>
                        <label
                          className="form-check-label d-inline-flex align-items-center"
                          htmlFor={item?.appUuid}
                        >
                          <span className="icon-wrap icon-sm me-2 p-0">
                            <img src={item?.image} alt="avatar" />
                          </span>
                          {item?.app_name}
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={item?.appUuid}
                          name={item?.appUuid}
                          checked={item[pathKeys[pathname]?.key]}
                          onChange={handleScreenShotSelected}
                        />
                      </div>
                    ))}
                  </div>
                </>
              ) : null}
              <div>
                <h6 className="mb-6 text-blue-900">
                  {getLangTranslation("SCREENSHOTS_SELECT_APPS", "SELECT APPS")}
                </h6>
              </div>
              <div className="card m-3 p-3 social-apps">
                {normalFormattedAllowedApps?.map((item, index) => (
                  <div className="form-check form-switch form-check-right mb-4" key={index}>
                    <label
                      className="form-check-label d-inline-flex align-items-center"
                      htmlFor={item?.appUuid}
                    >
                      <span className="icon-wrap icon-sm me-2 p-0">
                        <img src={item?.image} alt="avatar" />
                      </span>
                      {item?.app_name}
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={item?.appUuid}
                      name={item?.appUuid}
                      checked={item[pathKeys[pathname]?.key]}
                      onChange={handleScreenShotSelect}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="g-col-12 g-col-md-6">
              <h6 className="mb-6 text-blue-900">
                {getLangTranslation("SCREENSHOTS_SCREENSHOT_INTERVAL_TIME", "Screenshot interval time")}
              </h6>
              <div className="mb-6 d-flex flex-wrap justify-content-md-between gap-4">
                <div className="form-check form-check-inline me-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="time"
                    id="one"
                    value="1"
                    checked={parseInt(time) === 1}
                    onChange={handleTimeChange}
                  />
                  <label className="form-check-label text-dark" htmlFor="one">
                    {getLangTranslation("SCREENSHOTS_1_MIN", "1 min")}
                  </label>
                </div>
                <div className="form-check form-check-inline me-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="time"
                    id="two"
                    value="2"
                    checked={parseInt(time) === 2}
                    onChange={handleTimeChange}
                  />
                  <label className="form-check-label text-dark" htmlFor="two">
                    {getLangTranslation("SCREENSHOTS_2_MIN", "2 min")}
                  </label>
                </div>
                <div className="form-check form-check-inline me-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="time"
                    id="five"
                    value="5"
                    checked={parseInt(time) === 5}
                    onChange={handleTimeChange}
                  />
                  <label className="form-check-label text-dark" htmlFor="five">
                    {getLangTranslation("SCREENSHOTS_5_MIN", "5 min")}
                  </label>
                </div>
                <div className="form-check form-check-inline me-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="time"
                    id="ten"
                    value="10"
                    checked={parseInt(time) === 10}
                    onChange={handleTimeChange}
                  />
                  <label className="form-check-label text-dark" htmlFor="ten">
                    {getLangTranslation("SCREENSHOTS_10_MIN", "10 min")}
                  </label>
                </div>
                <div className="form-check form-check-inline me-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="time"
                    id="fifteen"
                    value="15"
                    checked={parseInt(time) === 15}
                    onChange={handleTimeChange}
                  />
                  <label className="form-check-label text-dark" htmlFor="fifteen">
                    {getLangTranslation("SCREENSHOTS_15_MIN", "15 min")}
                  </label>
                </div>
              </div>

              <p className="text-dark mb-6">
                {getLangTranslation("SCREENSHOTS_ENTER_THE_TIME_MANUALLY", "Enter the time manually")}
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="enterTime" className="mb-3 sr-only">
                      {getLangTranslation("SCREENSHOTS_ENTER_TIME", "Enter time")}
                    </label>
                    <input
                      type="text"
                      className="form-control text-dark"
                      id="enterTime"
                      placeholder="Enter time"
                      value={time}
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <Select
                    className="custom-select"
                    classNamePrefix="custom-select"
                    placeholder={getLangTranslation("SCREENSHOT_HISTORY_SELECT_DEVICE_TITLE", "Select Device")}
                    options={hourMinOptions}
                    value={hourMinOptions?.find((item) => item?.value === timeWise) || ""}
                    onChange={(val) => setTimeWise(val.value)}
                    isSearchable={false}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="row align-items-end g-3 mb-6">
            <div className="col-auto flex-grow-1">
              <div className="form-group">
                <label htmlFor="add" className="mb-3 text-dark">
                  {getLangTranslation("SCREENSHOTS_ADD_KEYWORDS_FOR_SCREENSHOT_CAPTURING", "Add keywords for screenshot capturing")}
                </label>
                <input
                  type="text"
                  className="form-control bg-white"
                  id="add"
                  placeholder="Enter keywords to be flagged separated by a coma"
                  name="keyword-input"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-primary" onClick={handleApply}> {/* Using new handleApply */}
                <span className="btn-upper-case">
                  {getLangTranslation("APPLY", "Apply")}
                </span>
              </button>
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-primary" onClick={handleClearAll}>
                <span className="btn-upper-case">
                  {getLangTranslation("PARENT_NOTIFICATION_FILTER_CLEAR_ALL", "CLEAR ALL")}
                </span>
              </button>
            </div>
          </div>
          <div className="d-inline-flex flex-wrap gap-3">
            {toggleData?.keystrokeKeywords?.map((item, index) => (
              <div className="custom-tag" key={item.id || index}>
                {item?.keyName}
                <i
                  className="icon-cancel ms-1 pt-cursor"
                  onClick={() => handleKeywordRemove(item?.id)}
                />
              </div>
            ))}
          </div>
        </>
      )}

      {!deviceSelected && (
        <div className="text-center my-3">
          -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
        </div>
      )}
    </>
  );
};

export default ScreenShots;